import { Resource } from './resource.entity';

export interface ProjectResources {
	id?: string;
	name?: string;
	description?: string;
	type?: TipoProyecto;
	funding_type?: TipoFinanciacion;
	resources?: Resource[];
}

export interface Project {
	id?: string;
	name?: string;
	description?: string;
	type?: TipoProyecto;
	funding_type?: TipoFinanciacion;
	hasDeliveries?: boolean;
}

export interface RecursoProject {
	id?: string;
	quantity?: number;
	observations?: string;
	apply_serial?: boolean;
	id_resource?: string;
	resource?: Resource;
}

export enum TipoProyecto {
	contrato = 0,
	convenio = 1,
}

export enum TipoFinanciacion {
	regalias = 0,
	recursosPropios = 1,
}

export type TipoRecurso = 'Insumo' | 'Fisico' | 'Digital' | 'Analogo';
